export enum AgreementType {
  CODE_OF_CONDUCT = 'CODE_OF_CONDUCT',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
}
